import React, { useEffect, useState } from "react";
import VybogTALLoaderAnimation from "../Dynamic-Animations/DynamicAnimations";

const HtmlResumePreview = ({ url }) => {
  const [html, setHtml] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    setHtml(null);
    setError(false);

    const loadHtml = async () => {
      try {
        if (!url) throw new Error("Missing resume URL");
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error("Failed to fetch resume");
        const content = await response.text();
        if (!controller.signal.aborted) setHtml(content);
      } catch (error) {
        if (!controller.signal.aborted) setError(true);
      }
    };

    loadHtml();
    return () => controller.abort();
  }, [url]);

  if (error) {
    return (
      <div
        role="alert"
        style={{ padding: "20px", color: "#d32f2f", textAlign: "center" }}
      >
        Failed to load the HTML resume. Please reopen the preview or try again.
      </div>
    );
  }

  if (html === null) {
    return (
      <div style={{ height: "100%", display: "grid", placeItems: "center" }}>
        <VybogTALLoaderAnimation />
      </div>
    );
  }

  return (
    <iframe
      title="HTML Resume Viewer"
      srcDoc={html}
      sandbox=""
      referrerPolicy="no-referrer"
      style={{
        width: "100%",
        height: "100%",
        border: "none",
        background: "white",
      }}
    />
  );
};

export default HtmlResumePreview;
